import type { IconSvgObject } from './types';

const Cursor01Icon: IconSvgObject = [
  ["path", { d: "M5.00081 18.9128L5.89315 2.47891C5.9161 2.05625 6.41957 1.84726 6.73736 2.12846L18.829 12.8282C19.1537 13.1155 18.9895 13.6496 18.5589 13.7068L13.4724 14.3827C13.1438 14.4264 12.9447 14.7669 13.0689 15.073L15.2917 20.5498C15.3967 20.8086 15.2711 21.1031 15.0112 21.2077L13.1331 21.9631C12.8731 22.0676 12.5772 21.9426 12.4722 21.6838L10.2754 16.2709C10.1435 15.946 9.72763 15.8501 9.46563 16.0841L5.84676 19.3162C5.51014 19.6169 4.9764 19.3623 5.00081 18.9128Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Cursor01Icon;
